import React, { useEffect } from "react";
import { Space } from "antd";
import PaletteService from "../services/palette.service";
import { useHeatmapLayersState } from "../states/HeatmapLayersState";
import { componentTheme } from "../themes/blueTheme";
import { otherIcons, variableIcons } from "../resources/menuIcons";
import { useTilemapLayersState } from "../states/TilemapLayersState";
import { usePlayingState } from "../states/PlayingState";

const { Player: playerTheme } = componentTheme.components;

export const PlayerLegend = () => {
  const {
    paletteDistribution,
    paletteMinMax,
    variable: variableHeatmap,
    domains: heatmapDomains,
  } = useHeatmapLayersState();

  const {
    variable: variableTiles,
    legendUrl,
    domains: tilemapDomains,
  } = useTilemapLayersState();

  const { domainType } = usePlayingState();

  const variable = variableHeatmap ? variableHeatmap : variableTiles;

  const showDynamicPalette = domainType == "heatmap" && heatmapDomains.length;

  useEffect(() => {
    if (showDynamicPalette) {
      let colorLegendComp = document.querySelector("color-legend");
      colorLegendComp.range = PaletteService.getColorsDistribution(
        "temperature",
        paletteDistribution,
        false
      );
      colorLegendComp.domain = [paletteMinMax.min, paletteMinMax.max];
    }
  }, [paletteDistribution, paletteMinMax, domainType]);

  const IconComponent = variableIcons[variable] || otherIcons.default;

  return (
    <div className="player-legend-container">
      <Space
        direction="horizontal"
        style={{ alignItems: "flex-start", columnGap: "0px" }}
      >
        <IconComponent
          style={{
            color: playerTheme.colorTextBase,
            marginRight: "3px",
          }}
          alt="Descripción del icono"
        />
        <span style={{ color: playerTheme.colorTextBase, fontSize: "14px" }}>
          {variable.charAt(0).toUpperCase() + variable.slice(1)}
        </span>
        {domainType == "tilemap" && (
          <img width={320} src={legendUrl} alt="Leyenda" />
        )}
        {domainType !== "tilemap" && showDynamicPalette && (
          <color-legend class="styled" titletext=""></color-legend>
        )}
      </Space>
    </div>
  );
};
